module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("\n                        Marken API\n                    ")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Auswahl Types",
      "dark": "",
      "cache-items": "",
      "required": "",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "id",
      "return-object": ""
    },
    model: {
      value: (_vm.ccType),
      callback: function($$v) {
        _vm.ccType = $$v
      },
      expression: "ccType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "offset-xs1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Auswahl Client",
      "dark": "",
      "required": "",
      "items": _vm.ccClients,
      "item-text": "name",
      "item-value": "id",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        _vm.changeSelected()
      }
    },
    model: {
      value: (_vm.ccClient),
      callback: function($$v) {
        _vm.ccClient = $$v
      },
      expression: "ccClient"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.configAPI
    }
  }, [_vm._v("\n                            API konfigurieren\n                        ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tsearch),
      callback: function($$v) {
        _vm.tsearch = $$v
      },
      expression: "tsearch"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredMarken,
      "search": _vm.tsearch,
      "select-all": "",
      "pagination": _vm.pagination,
      "item-key": "id",
      "rowsPerPageItems": [5, 10, 35, {
        text: 'Alle',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.all,
            "indeterminate": props.indeterminate
          },
          nativeOn: {
            "click": function($event) {
              _vm.toggleAll($event)
            }
          }
        })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            attrs: {
              "align": header.align
            },
            on: {
              "click": function($event) {
                _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', [_vm._v("arrow_upward")]), _vm._v("\n                                    " + _vm._s(header.text) + "\n                                ")], 1)
        }), _vm._v(" "), _c('th')], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(props.item.apimarke.name) + "\n                                ")]), _vm._v(" "), (props.item.apimarke.firmen.length !== 0) ? _c('td', [_vm._v("\n                                    " + _vm._s(props.item.apimarke.firmen[0].name) + " "), _c('br'), _vm._v("\n                                    " + _vm._s(props.item.apimarke.firmen[0].namezusatz) + "\n                                ")]) : _c('td'), _vm._v(" "), (props.item.apimarke.firmen.length !== 0 && props.item.apimarke.firmen[0].adressen.length !== 0) ? _c('td', [_vm._v("\n                                    " + _vm._s(props.item.apimarke.firmen[0].adressen[0].strasse) + " "), _c('br'), _vm._v("\n                                    " + _vm._s(props.item.apimarke.firmen[0].adressen[0].plz) + " " + _vm._s(props.item.apimarke.firmen[0].adressen[0].ort) + "\n                                ")]) : _c('td'), _vm._v(" "), _c('td', _vm._l((props.item.apimarke.types), function(type) {
          return _c('p', {
            key: type.id
          }, [_vm._v("\n                                        " + _vm._s(type.name) + "\n                                    ")])
        }))])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a0ef1c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/config/Markenapi.vue
// module id = 321
// module chunks = 0